var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.313,
    height: 13.316,
    viewBox: "0 0 13.313 13.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_30",
    "data-name": "Union 30",
    d: "M17832.023-2740.566l-4.951-4.949-4.949,4.949a1,1,0,0,1-1.416,0,1,1,0,0,1,0-1.414l4.949-4.949-4.949-4.947a1,1,0,0,1,0-1.414,1,1,0,0,1,1.416,0l4.947,4.947,4.953-4.951a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-4.951,4.951,4.951,4.949a1,1,0,0,1,0,1.414,1,1,0,0,1-.709.3A.986.986,0,0,1,17832.023-2740.566Z",
    transform: "translate(-17820.416 2753.587)",
    fill: "#16161A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.938c0c378c121386a7dac1d53a792c97.svg";
export { ForwardRef as ReactComponent };